import React from 'react';
import styled from 'styled-components';

type HeaderTwoComponentProps = {
  children: React.ReactNode
  mb?: string
}

const HeaderTwoStyle = styled.h2<{$mb?: string}>`
  color: #383432;
  font-size: 24px;
  font-weight: bold;
  margin: 0;
  margin-bottom: ${props => props.$mb};
`;

const HeaderTwo: React.FC<HeaderTwoComponentProps> = ({ children, mb }) => {
  return (
    <HeaderTwoStyle $mb={mb}>
      { children }
    </HeaderTwoStyle>
  );
};

export default HeaderTwo;
